module.exports = __webpack_public_path__ + "static/img/company_logo.2ecc4ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company_logo.png
// module id = lSr8
// module chunks = 1